<template>
  <div>
    <headTop head-title='设置' goUser="true">
     <!--  <router-link class="back" tag="div" slot="private-return" to="/user"><i class="icon-arrow_lift"></i></router-link> -->
    </headTop>
    <div class="content">
      <ul class="ul">
        <li class="li" @click="gotoRouteTry('/user/password')">
          <div class="left_part"><i class="icon icon_denglumima"></i><span class="title">修改登录密码</span></div><div class="minWord"><span></span><i class="icon icon-right"></i></div>
        </li>
      </ul>
    </div>
    <div class="logout-btn">
      <span class="btn" @click.stop.prevent='logout'>退出登录</span>
    </div>
  </div>
</template>

<script>
import headTop from '@/components/common/header/head'
import { mapState, mapMutations } from 'vuex'
import { userResource } from '@/resource/resource'
// import { getCookie } from '@/common/js/cookies'

const ERR_OK = 0

  export default {
    name: 'information',
    data () {
      return {
      }
    },
    computed: {
      ...mapState(['userInfo'])
    },
    created () {
    },
    mounted () {
    },
    methods: {
      // 退出登录
      logout () {
        userResource.logout().then(response => {
          response = response.body
          if (response.errcode === ERR_OK) {
            this.OUT_LOGIN()
            this.captcha = ''
            this.showCaptcha = false
            this.$router.push('/')
            // this.flag = false
          }
        })
      },
      gotoRouteTry (url) {
        if (this.userInfo && this.userInfo.user_type === 3) {
          this.$toast('抱歉，试玩账号不能进行该操作')
        } else {
          this.$router.push(url)
        }
      },
      gotoRoute (url) {
        this.$router.push(url)
      },
      // // 监听退出事件
      // onLogout () {
      //   this.eventLogout = setInterval(() => {
      //     if (!getCookie('isLogined')) {
      //       this.$router.push('/user')
      //       this.OUT_LOGIN()
      //       clearInterval(this.eventLogout)
      //     }
      //   }, 2000)
      // },
      // 更新vuex状态信息
      ...mapMutations([
        'OUT_LOGIN',
        'LEVELINFO'
      ])
    },
    components: {
      headTop
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import "../../common/stylus/mixin";
  // .back
  //   position absolute
  //   top 0
  //   left 0
  //   padding-left 0.2rem
  //   height 0.9rem
  //   line-height 0.9rem
  //   width 0.4rem
  //   color #fff
  //   font-size $font-size-m
  .content
    margin-top 0.9rem
    font-size $fz-t3
    .ul
      .li
        display flex
        justify-content space-between
        align-items center
        background-color #ffffff
        box-sizing border-box
        height 0.96rem
        // line-height 0.96rem
        border-bottom 1px solid #f4f4f4
        .left_part
          // line-height 0.96rem
          display flex
          align-items center
          .icon
            vertical-align middle
            display inline-block
            background-size cover
            background-repeat no-repeat
            width 0.4rem
            height 0.2rem
            margin-left 0.28rem
            &.icon_denglumima
              bg-image('icon_denglumima')
          .title
            color $c-b3
            margin-left 0.24rem
            line-height 0.36rem
        .minWord
          color #cccccc
          text-align right
          span
            display inline-block
            vertical-align middle
          .icon
            margin 0 0.3rem 0 0.22rem
            width 0.15rem
            height 0.26rem
            display inline-block
            background-size cover
            vertical-align middle
            background-repeat no-repeat
            &.icon-right
              bg-image('icon-right')
      .bar-li
        height 0.32rem
  .logout-btn
    position absolute
    bottom 1.6rem
    font-size $fz-t5
    text-align center
    left 0.28rem
    .btn
      width 6.94rem
      display block
      height 0.88rem
      line-height 0.88rem
      background-color $blue
      color #fff
      border-radius 0.06rem
</style>



// WEBPACK FOOTER //
// src/components/information/information.vue